import { Link } from "react-router-dom";
import { LogoWhite } from "../assets";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-primary py-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-5 px-6 text-white sm:flex-row sm:justify-between">
        <Link
          to="/"
          aria-label="Go to homepage"
          className="shrink-0"
        >
          <img
            src={LogoWhite}
            alt="Hotel Logo"
            className="h-auto w-[160px]"
          />
        </Link>

        <div className="text-center">
          <p>&copy; {year}. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}